import moment from 'moment';

export const DISCRIMINATOR_FACEBOOK = 1;
export const DISCRIMINATOR_RSS = 1;

export let formatDateDict = (prefix, alertTimeDelta) => {
  return (value, entry) => {
      if (!entry[prefix + '.year'])
        return null
      let res = new String(`${entry[prefix + '.year']}-${_.padStart(entry[prefix + '.month'], 2, 0)}-${_.padStart(entry[prefix + '.day'], 2, 0)}` +
        ` ${_.padStart(entry[prefix + '.hour'], 2, 0)}:${_.padStart(entry[prefix + '.minute'], 2, 0)}:${_.padStart(entry[prefix + '.second'], 2, 0)}`)
      if (alertTimeDelta && entry[alertTimeDelta + '.minutes']) {
        res.outdated = true;
      }
      return res;
  }
}

export let toTimestamp = (prefix) => {
  let dateFormatter = formatDateDict(prefix);
  return (value, entry) => {
    let dateString = dateFormatter(value, entry);
    let res = parseInt(moment(dateString, 'YYYY-MM-DD hh:mm:ss').format('X'), 10);
    return res;
  }
}

export let fromTimestamp = (value, entry) => {
  if (!value) {
    return value;
  }
  let date = moment(value, 'X');
  return {
    year: date.year(),
    month: date.month(),
    day: date.date(),
    hour: date.hour(),
    minute: date.minute(),
    second: date.second(),
    __type__: 'datetime'
  }
}

export let mapInterval = (prefix) => {
  return (value, entry) => {
      return {
          "hours": entry[prefix + '.hours'],
          "minutes": entry[prefix + '.minutes'],
          "seconds": entry[prefix + '.seconds']
      }
  }
}

export let getDiscriminatorField = (nga, name='discriminator') => {
  return nga.field(name, 'choice').choices(
        [
          {value: 1, label: 'Facebook'},
          {value: 2, label: 'Twitter'},
          {value: 5, label: 'RSS'},
          {value: 6, label: 'Instagram'},
          {value: 7, label: 'Email'},
      ]).validation({required: true})
}

export let getRoleEntity = (nga) => {
  return nga.entity('roles').label('Roles').url((entityName, viewType, identifierValue, identifierName) => 'security/role' + (identifierValue ? '/' + identifierValue : ''))
}

export let addViewErrorHandler = (view) => {
  return view.onSubmitError(['error', 'form', 'progression', 'notification', function(error, form, progression, notification) {
      // mark fields based on errors from the response
      console.log(error)
      let errorMessage;
      error.data.forEach(violation => {
          if (form[violation.propertyPath]) {
              form[violation.propertyPath].$valid = false;
              errorMessage = violation.message;
          }
      });
      // stop the progress bar
      progression.done();
      // add a notification
      notification.log(errorMessage, { addnCls: 'humane-flatty-error' });
      // cancel the default action (default error messages)
      return false;
  }])
}

export const msToMinutes = (prefix) => {
  return (value, entry) => {
    return value / 60000;
  }
}

export const minutesToMs = (prefix) => {
  return (value, entry) => {
    return value * 60000;
  }
}



// WEBPACK FOOTER //
// ./client/app/helpers.js